import { network } from '@utils'
import { handleReturn, MutationFunction, PaginatedResponse, QueryFunction } from './root'

export interface ISubFolder {
  id: number
  name: string
  parent: number
  for_mobile_uploads: boolean
}

export interface IFolder extends ISubFolder {
  children: ISubFolder[]
  breadcrumbs: ISubFolder[]
  has_content: boolean
  email: string
  email_passthrough: string | null
}

interface FolderListProps {
  slug: string
}

export const fetchFolders: QueryFunction<FolderListProps, PaginatedResponse<IFolder>> = async (
  { slug },
  params = null
) => {
  const url = `/v1/business/${slug}/folders/`
  const { data } = await network.httpClient.request({
    url,
    method: 'GET',
    params
  })
  return data
}

export const createFolder: MutationFunction<FolderListProps, IFolder> = async (
  { slug },
  requestData
) => {
  const url = `/v1/business/${slug}/folders/`
  const { data } = await network.httpClient.request({
    url,
    method: 'POST',
    data: requestData
  })
  return data
}

interface FolderInstanceProps extends FolderListProps {
  folderId: number
}

export const fetchFolder: QueryFunction<FolderInstanceProps, IFolder> = async (
  { slug, folderId },
  params = null
) => {
  const url = `/v1/business/${slug}/folders/${folderId}/`
  const { data } = await network.httpClient.request({
    url,
    method: 'GET',
    params
  })
  return data
}

export const updateFolder: MutationFunction<FolderInstanceProps, IFolder> = async (
  { slug, folderId },
  requestData
) => {
  const url = `/v1/business/${slug}/folders/${folderId}/`
  const { status, data } = await network.httpClient.request({
    url,
    method: 'PATCH',
    data: requestData,
    validateStatus: () => true
  })
  return handleReturn({ status, data })
}

export const deleteFolder: MutationFunction<FolderInstanceProps, unknown> = async ({
  slug,
  folderId
}) => {
  const url = `/v1/business/${slug}/folders/${folderId}/`
  await network.httpClient.request({
    url,
    method: 'DELETE'
  })
}

interface IMoveItem {
  type: string
  id: number
}

export interface IFolderMoveAction {
  target_folder_id: number
  items: IMoveItem[]
}

export const moveItemsToFolder: MutationFunction<FolderListProps, IFolderMoveAction> = async (
  { slug },
  requestData
) => {
  const url = `/v1/business/${slug}/folders/actions/move/`
  const { data } = await network.httpClient.request({
    url,
    method: 'POST',
    data: requestData
  })
  return data
}
